/**
 * Validation Constraints
 * Define min/max values and length constraints for validation
 */
export const VALIDATION_CONSTRAINTS = {
  year: {
    min: 1900,
    max: 2100,
  },
  name: {
    minLength: 1,
    maxLength: 100,
  },
  openingSentence: {
    minLength: 1,
    maxLength: 200,
  },
  title: {
    minLength: 2,
    maxLength: 50,
  },
} as const;
